/*---------------------------------------------------------------------------------------------
 *  Example Custom Component Code: Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../../shared/Globals";
import BaseCom from "../BaseCom";

export default class Shop extends BaseCom {


    properties(col, state, changeStateValue, onChange) {
        return (<>

        </>
        );
    }

    render() {
        return (
            <div class="container-fluid">
                <div class="row prod_pg1">

                    <div class="col-md-12 col-lg-3">
                        <div class="prod_pg1l">
                            <div class="prod_pg1l1 bg-white p-4">
                                <h6 class="mb-3">
                                    PRODUCT CATEGORIES
                                </h6>
                                <div class="prod_pg1l1i row">
                                    <div class="col-md-10 col-10">
                                        <div class="prod_pg1l1il">
                                            <h6 class="font_14 fw-normal mt-1">
                                                <a>
                                                    <i class="fa fa-circle-o me-1 col_yell"></i> DSLR Cameras
                                                </a>
                                            </h6>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-2">
                                        <div class="prod_pg1l1ir text-end">
                                            <h6 class="d-inline-block bg_light font_13">
                                                18
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                                <div class="prod_pg1l1i row mt-2">
                                    <div class="col-md-10 col-10">
                                        <div class="prod_pg1l1il">
                                            <h6 class="font_14 fw-normal mt-1">
                                                <a>
                                                    <i class="fa fa-circle-o me-1 col_yell"></i> Electronics
                                                </a>
                                            </h6>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-2">
                                        <div class="prod_pg1l1ir text-end">
                                            <h6 class="d-inline-block bg_light font_13">
                                                18
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                                <div class="prod_pg1l1i row mt-2">
                                    <div class="col-md-10 col-10">
                                        <div class="prod_pg1l1il">
                                            <h6 class="font_14 fw-normal mt-1">
                                                <a>
                                                    <i class="fa fa-circle-o me-1 col_yell"></i> Hybrid still/Video
                                                </a>
                                            </h6>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-2">
                                        <div class="prod_pg1l1ir text-end">
                                            <h6 class="d-inline-block bg_light font_13">6</h6>
                                        </div>
                                    </div>
                                </div>
                                <div class="prod_pg1l1i row mt-2">
                                    <div class="col-md-10 col-10">
                                        <div class="prod_pg1l1il">
                                            <h6 class="font_14 fw-normal mt-1">
                                                <a>
                                                    <i class="fa fa-circle-o me-1 col_yell"></i> Accessories
                                                </a>
                                            </h6>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-2">
                                        <div class="prod_pg1l1ir text-end">
                                            <h6 class="d-inline-block bg_light font_13">
                                                8
                                            </h6>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="prod_pg1l1 bg-white p-4 mt-4">
                                <h6 class="mb-3">FILTER BY PRICE</h6>
                                <input type="range" class="form-range" id="customRange1" />
                                <h6 class="mb-0 col_light font_13 mt-3">
                                    PRICE: $199 - $3,999.99
                                </h6>
                            </div>

                            <div class="prod_pg1l1 bg-white p-4 mt-4">
                                <h6 class="mb-3">
                                    RELATED PRODUCT
                                </h6>
                                <div class="prod_pg1l2i row">
                                    <div class="col-md-4 col-4">
                                        <div class="prod_pg1l2il">
                                            <div class="grid clearfix">
                                                <figure class="effect-jazz mb-0">
                                                    <a>
                                                        <img src="/img/placeholder/EOSR6-M2.png" class="w-100" alt="Related Items" />
                                                    </a>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-8 col-8">
                                        <div class="prod_pg1l2ir">
                                            <span class="col_yell">
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                            </span>
                                            <h6 class="text-capitalize mt-2 font_14">
                                                <a>
                                                    Canon EOS R5 MarkII
                                                </a>
                                            </h6>
                                            <h6 class="mt-2 mb-0 font_13 col_yell">
                                                $2,299.00
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                                <div class="prod_pg1l2i row mt-3">
                                    <div class="col-md-4 col-4">
                                        <div class="prod_pg1l2il">
                                            <div class="grid clearfix">
                                                <figure class="effect-jazz mb-0">
                                                    <a>
                                                        <img src="/img/placeholder/NikonZ8.png" class="w-100" alt="Related items" />
                                                    </a>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-8 col-8">
                                        <div class="prod_pg1l2ir">
                                            <span class="col_yell">
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                            </span>
                                            <h6 class="text-capitalize mt-2 font_14">
                                                <a>
                                                    Nikon Z8
                                                </a>
                                            </h6>
                                            <h6 class="mt-2 mb-0 font_13 col_yell">
                                                $3,696.95
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                                <div class="prod_pg1l2i row mt-3">
                                    <div class="col-md-4 col-4">
                                        <div class="prod_pg1l2il">
                                            <div class="grid clearfix">
                                                <figure class="effect-jazz mb-0">
                                                    <a>
                                                        <img src="/img/placeholder/sony-a7iii.png" class="w-100" alt="Related Items" />
                                                    </a>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-8 col-8">
                                        <div class="prod_pg1l2ir">
                                            <span class="col_yell">
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                            </span>
                                            <h6 class="text-capitalize mt-2 font_14"><a>Sony A7 III</a></h6>
                                            <h6 class="mt-2 mb-0 font_13 col_yell">$1,698.00</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="prod_pg1l1 bg-white p-4 mt-4">
                                <h6 class="mb-3">
                                    PRODUCT BRAND
                                </h6>
                                <div class="prod_pg1l1il">
                                    <div class="row">
                                        <h6 class="font_14 fw-normal col-lg-12 col-md-6  col-sm-6">
                                            <a>
                                                <i class="fa fa-circle-o me-1 col_yell"></i> New
                                            </a>
                                        </h6>
                                        <h6 class="font_14 fw-normal mt-3 col-lg-12 col-md-6  col-sm-6">
                                            <a>
                                                <i class="fa fa-circle-o me-1 col_yell"></i> Canon
                                            </a>
                                        </h6>
                                        <h6 class="font_14 fw-normal mt-3 col-lg-12 col-md-6  col-sm-6">
                                            <a>
                                                <i class="fa fa-circle-o me-1 col_yell"></i> Nikon
                                            </a>
                                        </h6>
                                        <h6 class="font_14 fw-normal mb-0 mt-3 col-lg-12 col-md-6  col-sm-6">
                                            <a>
                                                <i class="fa fa-circle-o me-1 col_yell"></i> Sony
                                            </a>
                                        </h6>
                                    </div>
                                    <hr />
                                </div>

                                <h6 class="mb-3">FILTER COLOR</h6>
                                <div class="row m-0">
                                    <div class="form-check col-md-6 col-6 col-lg-12">
                                        <input type="checkbox" class="form-check-input" id="customCheck1" />
                                        <label class="form-check-label" for="customCheck1"><a>Black (5)</a></label>
                                    </div>
                                    <div class="form-check col-md-6 col-6 col-lg-12 mt-2">
                                        <input type="checkbox" class="form-check-input" id="customCheck1" />
                                        <label class="form-check-label" for="customCheck1"><a>White (2)</a></label>
                                    </div>
                                    <div class="form-check col-md-6 col-6 col-lg-12 mt-2">
                                        <input type="checkbox" class="form-check-input" id="customCheck1" />
                                        <label class="form-check-label" for="customCheck1"><a>Gun Metal (4)</a></label>
                                    </div>
                                    <div class="form-check col-md-6 col-6 col-lg-12 mt-2">
                                        <input type="checkbox" class="form-check-input" id="customCheck1" />
                                        <label class="form-check-label" for="customCheck1"><a>Other (5)</a></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-9">
                        <div class="prod_pg1r">
                            <div class="prod_pg1r1 row">

                                <div class="col-md-9">
                                    <div class="prod_pg1r1l">
                                        <p class="mt-3 mb-0">Showing Products 1-9 Of 9 Products</p>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="prod_pg1r1r">
                                        <select name="categories" style={{height:'50px'}} class="form-select" required="">
                                            <option value="">Relevance</option>
                                            <option>Best sellers</option>
                                            <option>Name, A to Z</option>
                                            <option>Name, Z to A</option>
                                            <option>Price, high to low</option>
                                            <option>Price, low to high</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="prod_pg1r2 mt-4 row">

                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="prodinm clearfix">
                                        <div class="prod_2im position-relative clearfix">
                                            <div class="prod_2i1 clearfix">
                                                <div class="grid clearfix">
                                                    <figure class="effect-jazz mb-0">
                                                        <a>
                                                            <img src="/img/placeholder/EOS90D.jpg" class="w-100" alt="Canon EOS 90D" />
                                                        </a>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div class="prod_2i3 clearfix position-absolute w-100">
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3">NEW</h6>
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3 pull-right">40%</h6>
                                            </div>
                                            <div class="prod_2in clearfix position-absolute bg-light w-100 p-3 text-center">
                                                <ul class="mb-0">
                                                    <li class="d-inline-block me-3">
                                                        <a title="Add to Cart">
                                                            <i class="fa fa-circle-plus"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block me-3">
                                                        <a title="View Cart">
                                                            <i class="fa fa-shopping-cart"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block">
                                                        <a title="View Item Page">
                                                            <i class="fa fa-eye"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="prod_2i2 pt-4 pb-4 ps-3 pe-3 bg-white clearfix">
                                            <span class="col_yell">
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star-half-o"></i>
                                            </span>
                                            <h6 class="mt-2">
                                                <a>
                                                    Canon EOS 90D
                                                </a>
                                            </h6>
                                            <h6 class="font_13">
                                                <a class="col_light">
                                                    33Mpixel DSLR Camera
                                                </a>
                                            </h6>
                                            <hr />
                                            <h6 class="fw-normal mb-0"><span class="text-decoration-line-through col_light">$999.99</span> <span class="pull-right fw-bold col_yell">$725.00</span></h6>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="prodinm clearfix">
                                        <div class="prod_2im position-relative clearfix">
                                            <div class="prod_2i1 clearfix">
                                                <div class="grid clearfix">
                                                    <figure class="effect-jazz mb-0">
                                                        <a>
                                                            <img src="/img/placeholder/EOST7.png" class="w-100" alt="Canon EOS T7" />
                                                        </a>
                                                    </figure>
                                                </div>
                                            </div>

                                            <div class="prod_2i3 clearfix position-absolute w-100">
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3">
                                                    NEW
                                                </h6>
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3 pull-right">
                                                    40%
                                                </h6>
                                            </div>
                                            <div class="prod_2in clearfix position-absolute bg-light w-100 p-3 text-center">
                                                <ul class="mb-0">
                                                    <li class="d-inline-block me-3">
                                                        <a title="Add to Cart">
                                                            <i class="fa fa-circle-plus"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block me-3">
                                                        <a title="Go to Cart">
                                                            <i class="fa fa-shopping-cart"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block">
                                                        <a title="View Item Page">
                                                            <i class="fa fa-eye"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="prod_2i2 pt-4 pb-4 ps-3 pe-3 bg-white clearfix">
                                            <span class="col_yell">
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star-half-o"></i>
                                            </span>
                                            <h6 class="mt-2">
                                                <a>
                                                    Canon EOS Rebel T7
                                                </a>
                                            </h6>
                                            <h6 class="font_13">
                                                <a class="col_light">
                                                    24.1 Mpix DSLR Camera
                                                </a>
                                            </h6>
                                            <hr />
                                            <h6 class="fw-normal mb-0">
                                                <span class="text-decoration-line-through col_light">
                                                    $700.00
                                                </span>
                                                <span class="pull-right fw-bold col_yell">
                                                    $529.00
                                                </span>
                                            </h6>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="prodinm clearfix">
                                        <div class="prod_2im position-relative clearfix">
                                            <div class="prod_2i1 clearfix">
                                                <div class="grid clearfix">
                                                    <figure class="effect-jazz mb-0">
                                                        <a>
                                                            <img src="/img/placeholder/EOSR6-M2.png" class="w-100" alt="Canon EOS R6 Mark2" />
                                                        </a>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div class="prod_2i3 clearfix position-absolute w-100">
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3">
                                                    NEW
                                                </h6>
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3 pull-right">
                                                    40%
                                                </h6>
                                            </div>
                                            <div class="prod_2in clearfix position-absolute bg-light w-100 p-3 text-center">
                                                <ul class="mb-0">
                                                    <li class="d-inline-block me-3">
                                                        <a title="Add to Cart">
                                                            <i class="fa fa-circle-plus"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block me-3">
                                                        <a title="Go to Cart">
                                                            <i class="fa fa-shopping-cart"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block">
                                                        <a title="View Item Page">
                                                            <i class="fa fa-eye"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="prod_2i2 pt-4 pb-4 ps-3 pe-3 bg-white clearfix">
                                            <span class="col_yell">
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star-half-o"></i>
                                            </span>
                                            <h6 class="mt-2">
                                                <a>
                                                    Canon EOS R6 Mark II
                                                </a>
                                            </h6>
                                            <h6 class="font_13">
                                                <a class="col_light">
                                                    24.2 Mpixel, Mirrorless Hybrid Camera
                                                </a>
                                            </h6>
                                            <hr />
                                            <h6 class="fw-normal mb-0">
                                                <span class="text-decoration-line-through col_light">
                                                    $3,000.00
                                                </span>
                                                <span class="pull-right fw-bold col_yell">
                                                    $2,299.00
                                                </span>
                                            </h6>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="prodinm clearfix">
                                        <div class="prod_2im position-relative clearfix">
                                            <div class="prod_2i1 clearfix">
                                                <div class="grid clearfix">
                                                    <figure class="effect-jazz mb-0">
                                                        <a>
                                                            <img src="/img/placeholder/NikonZ8.png" class="w-100" alt="Nikon Z8" />
                                                        </a>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div class="prod_2i3 clearfix position-absolute w-100">
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3">
                                                    NEW
                                                </h6>
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3 pull-right">
                                                    40%
                                                </h6>
                                            </div>
                                            <div class="prod_2in clearfix position-absolute bg-light w-100 p-3 text-center">
                                                <ul class="mb-0">
                                                    <li class="d-inline-block me-3">
                                                        <a title="Add to Cart">
                                                            <i class="fa fa-circle-plus"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block me-3">
                                                        <a title="Go to Cart">
                                                            <i class="fa fa-shopping-cart"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block">
                                                        <a title="View Item Page">
                                                            <i class="fa fa-eye"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="prod_2i2 pt-4 pb-4 ps-3 pe-3 bg-white clearfix">
                                            <span class="col_yell">
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star-half-o"></i>
                                            </span>
                                            <h6 class="mt-2">
                                                <a>
                                                    Nikon Z8
                                                </a>
                                            </h6>
                                            <h6 class="font_13">
                                                <a class="col_light">
                                                    Hybrid stills/video Camera
                                                </a>
                                            </h6>
                                            <hr />
                                                <h6 class="fw-normal mb-0">
                                                    <span class="text-decoration-line-through col_light">
                                                        $3,999.99
                                                    </span>
                                                    <span class="pull-right fw-bold col_yell">
                                                        $3,696.95
                                                    </span>
                                                </h6>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="prodinm clearfix">
                                        <div class="prod_2im position-relative clearfix">
                                            <div class="prod_2i1 clearfix">
                                                <div class="grid clearfix">
                                                    <figure class="effect-jazz mb-0">
                                                        <a>
                                                            <img src="/img/placeholder/Nikon-Z6.png" class="w-100" alt="Canon EOS 90D" />
                                                        </a>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div class="prod_2i3 clearfix position-absolute w-100">
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3">
                                                    NEW
                                                </h6>
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3 pull-right">
                                                    40%
                                                </h6>
                                            </div>
                                            <div class="prod_2in clearfix position-absolute bg-light w-100 p-3 text-center">
                                                <ul class="mb-0">
                                                    <li class="d-inline-block me-3">
                                                        <a title="Add to Cart">
                                                            <i class="fa fa-circle-plus"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block me-3">
                                                        <a title="Go to Cart">
                                                            <i class="fa fa-shopping-cart"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block">
                                                        <a title="View Item Page">
                                                            <i class="fa fa-eye"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="prod_2i2 pt-4 pb-4 ps-3 pe-3 bg-white clearfix">
                                            <span class="col_yell">
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star-half-o"></i>
                                            </span>
                                            <h6 class="mt-2">
                                                <a>
                                                    Nikon Z6II
                                                </a>
                                            </h6>
                                            <h6 class="font_13">
                                                <a class="col_light">
                                                    Full Frame Mirrorless with Lens
                                                </a>
                                            </h6>
                                            <hr />
                                            <h6 class="fw-normal mb-0">
                                                <span class="text-decoration-line-through col_light">
                                                    $2,393.00
                                                </span>
                                                <span class="pull-right fw-bold col_yell">
                                                    $1,999.99
                                                </span>
                                            </h6>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="prodinm clearfix">
                                        <div class="prod_2im position-relative clearfix">
                                            <div class="prod_2i1 clearfix">
                                                <div class="grid clearfix">
                                                    <figure class="effect-jazz mb-0">
                                                        <a>
                                                            <img src="/img/placeholder/NikonD7500.png" class="w-100" alt="Canon EOS 90D" />
                                                        </a>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div class="prod_2i3 clearfix position-absolute w-100">
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3">NEW
                                                </h6>
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3 pull-right">
                                                    40%
                                                </h6>
                                            </div>
                                            <div class="prod_2in clearfix position-absolute bg-light w-100 p-3 text-center">
                                                <ul class="mb-0">
                                                    <li class="d-inline-block me-3">
                                                        <a title="Add to Cart">
                                                            <i class="fa fa-circle-plus"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block me-3">
                                                        <a title="Go to Cart">
                                                            <i class="fa fa-shopping-cart"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block">
                                                        <a title="View Item Page">
                                                            <i class="fa fa-eye"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="prod_2i2 pt-4 pb-4 ps-3 pe-3 bg-white clearfix">
                                            <span class="col_yell">
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star-half-o"></i>
                                            </span>
                                            <h6 class="mt-2">
                                                <a>
                                                    Nikon D7500 DSLR
                                                </a>
                                            </h6>
                                            <h6 class="font_13">
                                                <a class="col_light">
                                                    DX-format 4k UHD video / time-lapse recording
                                                </a>
                                            </h6>
                                            <hr />
                                            <h6 class="fw-normal mb-0"><span class="text-decoration-line-through col_light">$999.00</span> <span class="pull-right fw-bold col_yell">$746.95</span></h6>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="prodinm clearfix">
                                        <div class="prod_2im position-relative clearfix">
                                            <div class="prod_2i1 clearfix">
                                                <div class="grid clearfix">
                                                    <figure class="effect-jazz mb-0">
                                                        <a>
                                                            <img src="/img/placeholder/SonyAlpha-a6000.png" class="w-100" alt="DSLR Camera" />
                                                        </a>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div class="prod_2i3 clearfix position-absolute w-100">
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3">
                                                    NEW
                                                </h6>
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3 pull-right">
                                                    40%
                                                </h6>
                                            </div>
                                            <div class="prod_2in clearfix position-absolute bg-light w-100 p-3 text-center">
                                                <ul class="mb-0">
                                                    <li class="d-inline-block me-3">
                                                        <a title="Add to Cart">
                                                            <i class="fa fa-circle-plus"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block me-3">
                                                        <a title="Go to Cart">
                                                            <i class="fa fa-shopping-cart"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block">
                                                        <a title="View Item Page">
                                                            <i class="fa fa-eye"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="prod_2i2 pt-4 pb-4 ps-3 pe-3 bg-white clearfix">
                                            <span class="col_yell">
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star-half-o"></i>
                                            </span>
                                            <h6 class="mt-2">
                                                <a>
                                                    Sony Alpha A6000
                                                </a>
                                            </h6>
                                            <h6 class="font_13">
                                                <a class="col_light">
                                                    24.3Mpixel Mirrorless Hybrid camera
                                                </a>
                                            </h6>
                                            <hr />
                                            <h6 class="fw-normal mb-0">
                                                <span class="text-decoration-line-through col_light">
                                                    $699.99
                                                </span>
                                                <span class="pull-right fw-bold col_yell">
                                                    $595.95
                                                </span>
                                            </h6>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="prodinm clearfix">
                                        <div class="prod_2im position-relative clearfix">
                                            <div class="prod_2i1 clearfix">
                                                <div class="grid clearfix">
                                                    <figure class="effect-jazz mb-0">
                                                        <a>
                                                            <img src="/img/placeholder/sony-a7iii.png" class="w-100" alt="Canon EOS 90D" />
                                                        </a>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div class="prod_2i3 clearfix position-absolute w-100">
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3">
                                                    NEW
                                                </h6>
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3 pull-right">
                                                    40%
                                                </h6>
                                            </div>
                                            <div class="prod_2in clearfix position-absolute bg-light w-100 p-3 text-center">
                                                <ul class="mb-0">
                                                    <li class="d-inline-block me-3">
                                                        <a title="Add to Cart">
                                                            <i class="fa fa-circle-plus"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block me-3">
                                                        <a title="Go to Cart">
                                                            <i class="fa fa-shopping-cart"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block">
                                                        <a title="View Item Page">
                                                            <i class="fa fa-eye"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="prod_2i2 pt-4 pb-4 ps-3 pe-3 bg-white clearfix">
                                            <span class="col_yell">
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star-half-o"></i>
                                            </span>
                                            <h6 class="mt-2">
                                                <a>
                                                    Sony a7 III
                                                </a>
                                            </h6>
                                            <h6 class="font_13">
                                                <a class="col_light">
                                                    4k Hybrid Camera
                                                </a>
                                            </h6>
                                            <hr />
                                                <h6 class="fw-normal mb-0">
                                                    <span class="text-decoration-line-through col_light">
                                                        $1999.99
                                                    </span>
                                                    <span class="pull-right fw-bold col_yell">
                                                        $1,698.00
                                                    </span>
                                                </h6>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="prodinm clearfix">
                                        <div class="prod_2im position-relative clearfix">
                                            <div class="prod_2i1 clearfix">
                                                <div class="grid clearfix">
                                                    <figure class="effect-jazz mb-0">
                                                        <a>
                                                            <img src="/img/placeholder/Sony-zv-e10.png" class="w-100" alt="DSLR Camera" />
                                                        </a>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div class="prod_2i3 clearfix position-absolute w-100">
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3">NEW
                                                </h6>
                                                <h6 class="bg_yell d-inline-block pt-1 pb-1 font_13 text-white ps-3 pe-3 pull-right">
                                                    40%
                                                </h6>
                                            </div>
                                            <div class="prod_2in clearfix position-absolute bg-light w-100 p-3 text-center">
                                                <ul class="mb-0">
                                                    <li class="d-inline-block me-3">
                                                        <a title="Add to Cart">
                                                            <i class="fa fa-circle-plus"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block me-3">
                                                        <a title="Go to Cart">
                                                            <i class="fa fa-shopping-cart"></i>
                                                        </a>
                                                    </li>
                                                    <li class="d-inline-block">
                                                        <a title="View Item Page">
                                                            <i class="fa fa-eye"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="prod_2i2 pt-4 pb-4 ps-3 pe-3 bg-white clearfix">
                                            <span class="col_yell">
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star"></i>
                                                <i class="fa fa-star-half-o"></i>
                                            </span>
                                            <h6 class="mt-2">
                                                <a>
                                                    Sony ZV-E10
                                                </a>
                                            </h6>
                                            <h6 class="font_13">
                                                <a class="col_light">
                                                    Mirrorless 24.2MP Basic Bundle
                                                </a>
                                            </h6>
                                            <hr />
                                            <h6 class="fw-normal mb-0">
                                                <span class="text-decoration-line-through col_light">
                                                    $999.00
                                                </span>
                                                <span class="pull-right fw-bold col_yell">
                                                    $848.00
                                                </span>
                                            </h6>
                                        </div>
                                    </div>
                                </div>

                            </div>


                        </div>
                    </div>
                </div>
            </div>
        );
    }
}